import { css } from "@compiled/react";

import type { GlyphProps } from "@atlaskit/icon/types";

export const CloseIcon: React.FC<GlyphProps> = () => (
    <div
        css={css({
            width: "21px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        })}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="35"
            viewBox="0 0 17 35"
            fill="none"
        >
            <path
                d="M15 26L2.27208 13.2721"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <path
                d="M2 26L14.7279 13.2721"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
            />
        </svg>
    </div>
);
